import { render } from "./LbrxDisplayVerticalTheme.vue?vue&type=template&id=c5586322&scoped=true"
import script from "./LbrxDisplayVerticalTheme.vue?vue&type=script&lang=js"
export * from "./LbrxDisplayVerticalTheme.vue?vue&type=script&lang=js"

import "./LbrxDisplayVerticalTheme.vue?vue&type=style&index=0&id=c5586322&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5586322"]])

export default __exports__